import React from 'react';
import Aux from '../../../hoc/Axu';
import './Spinner.css';

const spinner = () => (
    <Aux>
        <div className="Spinner"><div></div><div></div><div></div><div></div></div>
    </Aux>
)

export default spinner;